export default {
  items: [
    {
      name : 'Index',
      url  : '/index',
      icon : 'icon-home',
    },
    {
      name   : 'Anime',
      url  : '/anime',
      icon : 'icon-social-github',
    },
    {
      name   : 'Game',
      url  : '/game',
      icon : 'icon-game-controller',
    },
    {
      name   : 'Movie',
      url  : '/movie',
      icon : 'icon-film',
    },
  ],
}
